<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12">
        <v-text-field :rules="[rules.required]" v-model="crud.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="crud.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-textarea rows="3" v-model="crud.description" label="Description"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-file-input
          v-model="crud.audio_file"
          label="Audio"
          show-size
          prepend-icon
          accept="audio/*"
          append-icon="mdi-music"
        >
          <template
            v-slot:selection
            v-if="typeof crud.audio_file === 'string'"
          >You already saved a file. Click to save a new one...</template>
        </v-file-input>
      </v-col>
      <v-col cols="12" class="font-weight-bold title">Template for Student</v-col>
      <v-col cols="12">
        <app-editor
          ref="template"
          :rules="[rules.required]"
          v-model="crud.question_group.questions[0].content"
        ></app-editor>
      </v-col>
      <v-col cols="12" class="font-weight-bold title">Answer</v-col>
      <v-col cols="12">
        <app-editor
          ref="answer"
          :rules="[rules.required]"
          v-model="crud.question_group.questions[0].good_answer"
        ></app-editor>
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto">Save</v-btn>
    </v-row>
  </v-form>
</template>

<script>
import Editor from '@/components/Utils/Editor.vue';
import rulesMixin from '@/mixins/rulesMixin';
import restoreMixin from '@/mixins/restoreMixin';
import {
  getPracticeAudioTranscript,
  postPracticeAudioTranscript,
  postQuestions,
} from '@/api/api';

export default {
  components: {
    appEditor: Editor,
  },
  mixins: [rulesMixin, restoreMixin],
  data() {
    return {
      loading: false,
      crud: {
        title: '',
        subtitle: '',
        description: '',
        audio_file: undefined,
        question_group: {
          questions: [
            {
              title: 'Transcript',
              good_answer: {
                type: 'doc',
                content: [
                  {
                    type: 'paragraph',
                    content: [
                      {
                        type: 'text',
                        text: 'Good Answer here...',
                      },
                    ],
                  },
                ],
              },
              content: {
                type: 'doc',
                content: [
                  {
                    type: 'paragraph',
                    content: [
                      {
                        type: 'text',
                        text: 'Template for your students here...',
                      },
                    ],
                  },
                ],
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    practice() {
      return this.$store.getters['admin/practice'];
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let crud = { ...this.crud };
      let question_group = { ...crud.question_group };
      crud.practice = this.practice.uuid;

      question_group.questions[0].content = JSON.stringify(
        question_group.questions[0].content,
      );

      question_group.questions[0].good_answer = JSON.stringify(
        question_group.questions[0].good_answer,
      );

      const response = await postPracticeAudioTranscript(crud);
      this.crud.uuid = response.data.uuid;

      if (response.data.question_group.uuid) {
        question_group.uuid = response.data.question_group.uuid;
      } else question_group.uuid = response.data.question_group;
      let questions = await postQuestions(question_group);
      questions.questions[0].content = JSON.parse(
        questions.questions[0].content,
      );
      questions.questions[0].good_answer = JSON.parse(
        questions.questions[0].good_answer,
      );

      this.crud.question_group = questions;
      this.loading = false;
    },
    async create() {
      const uuid = this.practice.audio_transcript_step;
      if (uuid) {
        const response = await getPracticeAudioTranscript(uuid);
        let crud = response.data;

        crud.question_group.questions[0].good_answer = JSON.parse(
          crud.question_group.questions[0].good_answer,
        );
        this.$refs.answer.editor.setContent(
          crud.question_group.questions[0].good_answer,
        );

        crud.question_group.questions[0].content = JSON.parse(
          crud.question_group.questions[0].content,
        );
        this.$refs.template.editor.setContent(
          crud.question_group.questions[0].content,
        );

        this.crud = { ...crud };
      }
    },
  },
  created() {
    this.create();
  },
};
</script>